// Location: assets/brand-collection.js
// What: Enables mouse dragging for native brand story and product scrollers.
// Why: Matches direct touch interaction while preserving ordinary links and vertical scrolling.
// RELEVANT FILES: sections/brand-story.liquid, sections/brand-group.liquid, assets/brand-collection.css
(() => {
  if (document.documentElement.dataset.brandDragReady) return;
  document.documentElement.dataset.brandDragReady = 'true';
  let gesture = null;
  let suppressedCarousel = null;
  let suppressedUntil = 0;

  const finish = (event) => {
    if (!gesture || (event.pointerId != null && event.pointerId !== gesture.pointerId)) return;
    const { carousel, pointerId, dragging } = gesture;
    gesture = null;
    carousel.classList.remove('is-dragging');
    if (carousel.hasPointerCapture(pointerId)) carousel.releasePointerCapture(pointerId);
    if (dragging) {
      suppressedCarousel = carousel;
      suppressedUntil = Date.now() + 500;
    }
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const carousel = event.target.closest('[data-brand-drag]');
    if (!carousel || carousel.scrollWidth <= carousel.clientWidth) return;
    if (event.target.closest('button, input, textarea, select')) return;
    suppressedCarousel = null;
    gesture = { carousel, pointerId: event.pointerId, x: event.clientX, y: event.clientY, left: carousel.scrollLeft, dragging: false };
  });

  document.addEventListener('pointermove', (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (!gesture.dragging) {
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
      if (Math.abs(dy) > Math.abs(dx)) { gesture = null; return; }
      gesture.dragging = true;
      gesture.carousel.classList.add('is-dragging');
      gesture.carousel.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    gesture.carousel.scrollLeft = gesture.left - dx;
  });

  document.addEventListener('pointerup', finish);
  document.addEventListener('pointercancel', finish);
  document.addEventListener('lostpointercapture', finish);
  window.addEventListener('blur', finish);
  document.addEventListener('dragstart', (event) => {
    if (event.target.closest('[data-brand-drag]')) event.preventDefault();
  });
  document.addEventListener('click', (event) => {
    if (Date.now() < suppressedUntil && suppressedCarousel?.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressedCarousel = null;
    }
  }, true);
})();
